#import "../fragments/product-context-fragment.graphql"

query GetEmailSequenceContext {
    products {
        edges {
            node {
                ...ProductContext
            }
        }
    }
}
